"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Logo = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = require("styled-components");
const useCulture_1 = __importDefault(require("../../hooks/useCulture"));
const useHomepage_1 = __importDefault(require("../../hooks/useHomepage"));
const useRouting_1 = __importDefault(require("../../hooks/useRouting"));
const useTransparency_1 = __importDefault(require("../../hooks/useTransparency"));
const Styled = __importStar(require("./styles"));
const Logo = ({ logo, loading, homes }) => {
    const { generateHomeUrl } = (0, useRouting_1.default)();
    const theme = (0, styled_components_1.useTheme)();
    const { culture } = (0, useCulture_1.default)();
    const { isTransparent } = (0, useTransparency_1.default)();
    const { setHighlighted } = (0, useHomepage_1.default)();
    const siteId = (culture === null || culture === void 0 ? void 0 : culture.siteId) || 1;
    const handleClick = () => {
        const defaultHome = homes === null || homes === void 0 ? void 0 : homes.find((h) => h.name === 'Default');
        if (!defaultHome)
            return;
        setHighlighted({ displayName: defaultHome.displayName, isReduced: defaultHome.isReduced, name: defaultHome.name });
    };
    if (logo) {
        return (0, react_1.cloneElement)(logo, { isTransparent });
    }
    if (loading) {
        return theme.name === 'privalia' ? (0, jsx_runtime_1.jsx)(Styled.PlaceholderPrivalia, {}) : (0, jsx_runtime_1.jsx)(Styled.PlaceholderVP, {});
    }
    return ((0, jsx_runtime_1.jsx)(Styled.Link, { href: generateHomeUrl(undefined, 'default'), onClick: handleClick, "data-testid": "header-logo-link", children: (0, jsx_runtime_1.jsx)(Styled.Logo, { siteId: siteId, isWhite: isTransparent, withParte: true, isTwoLine: false, "data-facil-iti": "header-logo", alt: "header logo" }) }));
};
exports.Logo = Logo;
exports.default = exports.Logo;
